export const AVATAR_SIZE_DEFAULT = 100;
